// extracted by mini-css-extract-plugin
export default {"steps-main-box":"StepsMain_steps-main-box__kFAhb","img-box":"StepsMain_img-box__LzBFL","fadeInLeft":"StepsMain_fadeInLeft__016-T"};